// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"FO-z","inlineTitle":"GO-z","sponsoredAdsWrapper":"HO-z","marketplaceRecosWrapper":"IO-z"};